import React, { useEffect } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useRelatorioEtiquetasInternadas from './RelatorioEtiquetasInternadasHook'

function RelatorioEtiquetasInternadas({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useRelatorioEtiquetasInternadas()

  useEffect(() => {
    localDispatch.getEstoque(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onSelectedEstoque(state.selectedEstoque, selectedTp)
  }, [state.selectedEstoque])

  // Render
  return (
    <>
      <PageHeader>8.17 - Relatório de Etiquetas Internadas no Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid">
            <div className="p-col-4">
              <CustomDropdown
                label={'Estoque'}
                options={state.estoques}
                value={state.selectedEstoque}
                onChange={value => localDispatch.onEstoqueChange(value, selectedTp)}
              />
            </div>
            <div
              className="p-col-3"
              style={{ paddingTop: 33, display: 'flex', alignItems: 'center', gap: 10 }}
            >
              <Btn
                onClick={() =>
                  localDispatch.onBtnEmitirRelatorioPdf(
                    state.posicoesEstoque.filter(f => f.selected),
                    selectedTp,
                  )
                }
              >
                Emitir Relatório PDF
              </Btn>
              <Btn
                onClick={() =>
                  localDispatch.onBtnEmitirRelatorioExcel(
                    state.posicoesEstoque.filter(f => f.selected),
                    selectedTp,
                    state.estoques.find(e => e.value === state.selectedEstoque),
                  )
                }
              >
                Emitir Relatório Excel
              </Btn>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={() => localDispatch.onChangeSelecionarTodos(!state.selecionarTodos)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.posicoesEstoque}
                emptyMessage={'Nenhuma posição de estoque encontrada para o estoque selecionado'}
                rows={15}
                paginator={true}
              >
                <Column
                  header={'#'}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => localDispatch.onItemClicked(item)}
                    />
                  )}
                  style={tableCellCentered(60)}
                />
                <Column field={'id'} header={'Código'} style={tableCellCentered(100)} />
                <Column field={'endereco'} header={'Endereço'} />
                <Column
                  field={'quantidade_etiquetas'}
                  header={'Quantidade Etiquetas'}
                  style={tableCellCentered(180)}
                />
                <Column field={'sequencia'} header={'Sequência'} style={tableCellCentered(150)} />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioEtiquetasInternadas))
